import {CxEvent} from '@spartacus/core';
import {AdobeTrackingProductData} from '@app/services/analytics/models/adobe-tracking-data';

export class EddlFormSubmitEvent extends CxEvent {
  static readonly type = 'EddlFormSubmitEvent';
  transactionId?: string;
  name?: string;
  country?: string;
  products?: AdobeTrackingProductData[];
}
